import type { CSSProperties } from 'react';

export const centeredToastStyle = (top: string | number, maxWidthPx = 475): CSSProperties => ({
  whiteSpace: 'pre-line',
  position: 'fixed',
  top,
  left: '50%',
  transform: 'translateX(-50%)',
  maxWidth: '92vw',
  width: `min(${maxWidthPx}px, 92vw)`,
  boxSizing: 'border-box',
  padding: '12px 16px',
  border: '2px solid #000',
  borderRadius: '8px',
  zIndex: 1300,
});
